import React, {Component} from "react";
import {connect} from "react-redux";
import {mapSlideToProps} from "../../../redux_reducers/utils";
import {Loading} from "../components/components";
import {IconButton, Stack, Tooltip} from "@mui/material";
import {morphleBaseTheme1} from "../themes";
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import {getImageShape, isOpenLayersMap} from "../utils/map_utils";
import {requestOsdFeature} from "../openseadragon/viewerSelection";
import {cropCanvas, degreeToRadian, getBarcodeUrl, getLoggedInUserId, isWhitePixel} from "../../../utils/utils";
import {fromExtent} from "ol/geom/Polygon";
import {store} from "../../../helper/store";
import {addAnnotation, deleteAnnotation} from "../../../redux_actions/maps.state.action";
import {AnnotationsConstants} from "../../../utils/const";
import {getCenter} from "ol/extent";
import LineString from "ol/geom/LineString";
import html2canvas from "html2canvas";
import {error_manager} from "../../../helper/error_manager";
import IosShareIcon from '@mui/icons-material/IosShare';
import {get} from "../../../helper/request";

class EditAnnoLabel extends Component {

    constructor(props) {
        super(props);

        // Scanner specific parameter
        this.height = 25;
        this.width = 75;

        // Printing specific parameter
        this.shiftPixel = 20;
        this.state = {
            jsPDFModule: null,
            x: 0,
            y: 0,
            isActive: true,
            xDest: 0,
            yDest: 0,
            widthDest: 0,
            heightDest: 0,
        };

    }

    componentDidMount() {
        import('jspdf').then((module) => {
            this.setState({jsPDFModule: module.default});
        });
    }

    createMapBorder = () => {
        this.deleteBorderAnnotation();
        const canvasEl = document.getElementById(`slide-map-${this.props.activeMapId}`);
        let backgroundColor = canvasEl.style.backgroundColor;
        canvasEl.style.backgroundColor = 'rgb(255, 255, 255)';
        let olLine = document.getElementsByClassName("ol-scale-line");
        olLine.length > 0 && (olLine[0].style.visibility = "hidden");

        html2canvas(canvasEl).then(canvas => {
            let context = canvas.getContext("2d");
            // X, Y, Height and Width of Destination Canvas
            let xDest = 0
            let yDest = 0
            let widthDest = canvas.width;
            let heightDest = canvas.height;

            //Get X Position of Slide in Canvas
            for (let i = 0; i < canvas.width; i++) {
                let pixelData = context.getImageData(i, canvas.height / 2, 1, 1).data;
                if (!isWhitePixel(pixelData)) {
                    xDest = i;
                    break;
                }
            }

            //Get Width of Slide in Canvas
            for (let i = canvas.width - 1; i > xDest; i--) {
                let pixelData = context.getImageData(i, canvas.height / 2, 1, 1).data;
                if (!isWhitePixel(pixelData)) {
                    widthDest = i - xDest;
                    break;
                }
            }

            //Get Y Position of Slide in Canvas
            for (let i = 0; i < canvas.height; i++) {
                let pixelData = context.getImageData(canvas.width / 2, i, 1, 1).data;
                if (!isWhitePixel(pixelData)) {
                    yDest = i;
                    break;
                }
            }

            //Get Height of Slide in Canvas
            for (let i = canvas.height - 1; i > yDest; i--) {
                let pixelData = context.getImageData(canvas.width / 2, i, 1, 1).data;
                if (!isWhitePixel(pixelData)) {
                    heightDest = i - yDest;
                    break;
                }
            }
            canvasEl.style.backgroundColor = backgroundColor;

            Promise.all([get(`/api/slide/get_points_in_mm/${this.props.slide.id}/`)]).then(([response]) => {
                let [x_shift, y_shift, x, y] = response;
                const minCoord = this.props.slidemap.getCoordinateFromPixel([xDest - x_shift, yDest - x_shift]);
                const maxCoord = this.props.slidemap.getCoordinateFromPixel([xDest + widthDest + x_shift, yDest + heightDest + x_shift]);
                const geometry = fromExtent([minCoord[0], minCoord[1], maxCoord[0], maxCoord[1]]);

                store.dispatch(addAnnotation(this.props.activeMapId, {
                    area: geometry.getArea(),
                    perimeter: new LineString(geometry.getLinearRing(0).getCoordinates()).getLength(),
                    color: '#000',
                    new_bounds: JSON.stringify(geometry.getCoordinates()),
                    slide: this.props.slide.id,
                    creator: getLoggedInUserId(),
                    shape: AnnotationsConstants.POLYGON,
                    tool_type: "Rectangle",
                    center: getCenter(geometry.getExtent()).toString(),
                    anno_drawer: this.props.layer.values_.drawer,
                    created_z_level: this.props.slidemap.getView().getZoom(),
                    title: 'Border',
                }));

                this.setState({
                    x: x, y: y, xDest: xDest - x_shift, yDest: yDest - y_shift,
                    widthDest: widthDest + x_shift * 2, heightDest: heightDest + y_shift * 2
                });
            })

        });
    }

    generatePdfFromImage = (x, y) => {

        const {xDest, yDest, widthDest, heightDest} = this.state;

        const canvasEl = document.getElementById(`slide-map-${this.props.activeMapId}`);
        let backgroundColor = canvasEl.style.backgroundColor;
        let filter = canvasEl.style.filter;
        // canvasEl.style.backgroundColor = 'rgb(255, 255, 255)';
        let olLine = document.getElementsByClassName("ol-scale-line");
        olLine.length > 0 && (olLine[0].style.visibility = "hidden");

        html2canvas(canvasEl).then(canvas => {
            //Crop the Canvas to Get Onlt Slide Data
            let croppedCanvas = cropCanvas(canvas, xDest, yDest, widthDest, heightDest);
            let croppedContext = croppedCanvas.getContext("2d");
            croppedContext.filter = filter;

            canvasEl.style.backgroundColor = backgroundColor;
            olLine.length > 0 && (olLine[0].style.visibility = "visible");

            let imageData = croppedCanvas.toDataURL()
            // Default export is A4 paper, portrait, using millimeters for units.
            let slide = this.props.slide;
            const {jsPDFModule} = this.state;
            const doc = new jsPDFModule({unit: 'mm', format: 'a4', orientation: 'portrait'});

            let fullImg = new Image()
            fullImg.src = imageData;

            let barcodeImg = new Image();
            barcodeImg.crossOrigin = 'anonymous';
            barcodeImg.src = getBarcodeUrl(slide);

            Promise.all([fullImg.decode(), get(`/api/slide/selected_region_points/${slide.id}/mm/`)
            ]).then(([ret1, data]) => {

                let [x0, y0, x1, y1] = data;
                doc.setFillColor(backgroundColor);

                doc.rect(this.shiftPixel, this.shiftPixel, this.width, this.height, "F");
                // doc.rect(x0 + this.shiftPixel, y0 + this.shiftPixel, x1 - x0, y1 - y0, "S");

                doc.addImage(
                    imageData,
                    "PNG",
                    x0 + this.shiftPixel - x,
                    y0 + this.shiftPixel - y,
                    x1 - x0 + (x * 2), //width
                    y1 - y0 + (y * 2), //height
                );

                doc.addImage(
                    barcodeImg,
                    "JPG",
                    50 + this.shiftPixel,
                    this.shiftPixel,
                    25,
                    25,
                );
                doc.save(`${slide.name}.pdf`);
            }).then(() => this.deleteBorderAnnotation())
                .catch(error => {
                    this.deleteBorderAnnotation();
                    console.error("Overlay Mask for Path file absent")
                    error_manager("PDF generation encountered an issue: a necessary file is missing", error)
                });
        })

    };

    deleteBorderAnnotation = () => {
        let annotations = this.props.annotationState.annotations;
        annotations.forEach(annotation => {
            if (annotation.title === 'Border' && annotation.color === '#000')
                store.dispatch(deleteAnnotation(this.props.activeMapId, annotation))
        })
    }

    exportHandler = () => requestOsdFeature('edit_anno_label').then(proceed => {
        if (proceed && isOpenLayersMap(this.props.slidemap)) this.exportOnOpenLayers();
    });

    exportOnOpenLayers = () => {

        const {isActive, x, y} = this.state;

        let center = this.props.slidemap.getView().getCenter();
        let rotation = this.props.slidemap.getView().getRotation();
        let zoom = this.props.slidemap.getView().getZoom();
        let minZoom = this.props.slidemap.getView().getMinZoom();

        this.props.slidemap.getView().setMinZoom(1);
        this.props.slidemap.getView().animate({
            center: getImageShape(this.props.slide).map(x => x / 2),
            rotation: degreeToRadian(90),
            zoom: 1,
            duration: 500,
        }, () =>
            setTimeout(() => {
                if (isActive) {
                    this.createMapBorder();
                } else {
                    this.generatePdfFromImage(x, y, () => {
                        this.props.slidemap.getView().setMinZoom(minZoom);
                        this.props.slidemap.getView().animate({
                            center, rotation, zoom,
                            duration: 500,
                        })
                    });
                }

                this.setState((prevState) => ({
                    isActive: !prevState.isActive,
                }));
            }, 500));
    }

    render() {
        if (!this.props.slidemap) return <Loading/>;
        const {isActive} = this.state;

        return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
            <Tooltip title={isActive ? "Edit Anno Label" : "Export PDF"} placement={"bottom"}>
                <IconButton size="small" onClick={this.exportHandler}>
                    {isActive ? <EditLocationAltIcon sx={{color: morphleBaseTheme1.palette.headBarIcon.primary}}/> :
                        <IosShareIcon sx={{color: morphleBaseTheme1.palette.headBarIcon.primary}}/>}
                </IconButton>
            </Tooltip>
        </Stack>
    }

}

export default connect(mapSlideToProps)(EditAnnoLabel)